module.exports = __webpack_public_path__ + "img/ski-boot.97ad9aab.svg";